import {getMonitorLifecycleTexts, useMonitorToggle} from 'entities/monitor';
import {domainMonitorAPI} from 'features/domain/api/domainMonitorAPI';

import IDomainMonitorOutput from './DomainMonitor/IDomainMonitor';

export const useDomainMonitorToggle = (
    item: Pick<IDomainMonitorOutput, 'uuid' | 'active'>,
    onLimit: () => void,
) => {
    const [updateDomainMonitor] = domainMonitorAPI.useUpdateDomainMonitorMutation();
    const texts = getMonitorLifecycleTexts();

    return useMonitorToggle({
        isActive: item.active,
        isPaused: !item.active,
        pause: () => updateDomainMonitor({uuid: item.uuid, active: false}).unwrap(),
        resume: () => updateDomainMonitor({uuid: item.uuid, active: true}).unwrap(),
        pausedText: texts.paused,
        resumedText: texts.resumed,
        onLimit,
    });
};

export default useDomainMonitorToggle;
